<script setup>
import MetricBox from './MetricBox.vue';
import AddMetric from './AddMetric.vue';

import { ref, defineProps, onMounted, defineEmits } from 'vue';
import { useDashboardStore } from '../../store/dashboard';

const dashboardStore = useDashboardStore();
const props = defineProps({
    metrics: {
        type: Array,
        required: true,
    },
    metricsAvailableList: {
        type: Array,
        required: true,
    },
    userGroupAvailableList: {
        type: Array,
        required: true,
    },
    specialUserGroupAvailableList: {
        type: Array,
        required: true,
    },
});

const items = ref([]);
const drag = ref(false);
const addMetricDialog = ref(false);
// vuedraggable options for dragging elements
const dragOptions = {
    animation: 200,
    group: 'description',
    disabled: false,
    ghostClass: 'ghost',
};

const emit = defineEmits(['addItem', 'updateMetricsList']);

onMounted(() => {
    items.value = props.metrics;
});

function onRemoveFromMetricsList(id) {
    items.value = items.value.filter(function( detail ) {
        return detail.id !== id;
    });

    onChanged();
}


function onChanged() {
    // update the positions in the dashboard states as well
    //dashboardStore.changeMetricOrders(items.value);

    reCalcOrderOfList(items);

    emit('updateMetricsList', items.value);
}


function reCalcOrderOfList(list) {
    let order = 1;

    list.value.forEach((element) => {
        element.order = order++;
    })
}

function addItem(metric) {
    dashboardStore.addMetricInDashboard(metric);
    addMetricDialog.value = false;
    emit('addItem', metric);
}
</script>

<template>
    <div class="grid">
        <div class="col-8 grid mt-2 mr-1">
            <div v-show="props.metrics && props.metrics.length" class="col-6 card " v-for="item in props.metrics" :key="item">
                <metric-box
                    class="h-15rem"
                    :metric="item"
                    @removeFromMetricsList="onRemoveFromMetricsList"
                    :metrics-available-list="metricsAvailableList"
                    :user-group-available-list="userGroupAvailableList"
                    :specialUserGroupAvailableList="specialUserGroupAvailableList"
                />
            </div>
            <!-- Section to add metric in the dashboards -->
            <div class="col-6">
                <div class="box h-15rem" @click="addMetricDialog = true">
                    <div class="plus-sign">+</div>
                    <div class="add-text">Add Metric</div>
                </div>
            </div>
        </div>

        <!-- Check if metrics length is more than 1, because its no use rearranging if there is only one metric -->
        <div class="col-4" v-show="props.metrics && props.metrics.length > 1">
            <div class="card">
                <h5>Metrics Positions:</h5>
                <p>You can reorder the metrics positions here</p>
                <draggable
                    class="list-groups"
                    :component-data="{
                        tag: 'ul',
                        type: 'transition-group',
                        name: !drag ? 'flip-list' : null,
                    }"
                    :list="items"
                    itemKey="id"
                    v-bind="dragOptions"
                    @start="drag = true"
                    @end="drag = false"
                    @change="onChanged"
                >
                    <template #item="{ element, index }">
                        <div class="item">
                            <div class="">
                                <b>{{ index + 1 }}</b> {{ '- ' + (element.name ?? 'Metric') }}
                            </div>
                        </div>
                    </template>
                </draggable>
            </div>
        </div>
    </div>
    <div v-if="addMetricDialog">
        <AddMetric
            @hide-dialog="addMetricDialog = false"
            @add-item="addItem"
            :metrics-available-list="metricsAvailableList"
            :user-group-available-list="userGroupAvailableList"
            :specialUserGroupAvailableList="specialUserGroupAvailableList"
        />
    </div>
</template>

<style>
/* Manage Metrics */
.metrics-container {
    max-height: 70vh;
    overflow-y: auto;
}
/* Metric positions item class */
.metrics-position-container {
    height: 50vh;
    overflow-y: auto;
}
.item {
    display: flex;
    justify-content: space-between;
    padding: 8px;
    border: 1px solid #ccc;
    background-color: #f9f9f9;
}
/** Add Metric Box section */
.box {
    border: 2px dotted #333;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: relative;
}

.plus-sign {
    font-size: 36px;
    line-height: 1;
}

.add-text {
    margin-top: 8px;
}
</style>
